import { Box, styled } from "@mui/material";
import { useIsScrolling } from "@platform/hooks";

import background from "../assets/dashboard_background.svg";

import type { Theme } from "@mui/material/styles";

const DashboardContainer: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { isScrolling } = useIsScrolling();
  return (
    <DashboardStyled isScrolling={isScrolling}>{children}</DashboardStyled>
  );
};

// While the page sits at the top the app bar floats over the brand artwork, so
// the header text turns white and the bar loses its own surface. Scrolling
// restores the bar's normal surface and colors.
export const DashboardStyled = styled(Box, {
  shouldForwardProp: (prop) => "isScrolling" !== prop,
})<{ isScrolling: boolean }>(({
  theme,
  isScrolling,
}: {
  theme: Theme;
  isScrolling: boolean;
}) => {
  const { palette } = theme.vars ?? theme;
  const white = theme.palette.common.white;
  return {
    backgroundImage: `url(${background})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "100%",
    '[data-mui-color-scheme="dark"] &': {
      backgroundImage: "none",
      backgroundColor: palette.background.default,
    },
    ...(!isScrolling && {
      ".app-bar-tabs a": {
        color: `${white} !important`,
      },
      ".app-bar-tabs-overflow-trigger": {
        color: `${white} !important`,
      },
      ".user-menu > button > *": {
        color: `${white} !important`,
      },
      ".MuiAppBar-root": {
        boxShadow: "none",
        color: white,
        background: "transparent",
        position: "relative",
      },
    }),
  };
});

export { DashboardContainer };
